import { WEATHER_MAP_RESIZABLE_LAYOUT_DEFAULTS } from '../../config/weatherMapLayout.config';
import {
  getDefaultWeatherMapLayoutOrientation,
  resolveWeatherMapLayoutOrientation,
} from '../../utils/weatherMapLayout.utils';
import ResizableWeatherMapLayout from './components/ResizableWeatherMapLayout/ResizableWeatherMapLayout';
import StaticWeatherMapLayout from './components/StaticWeatherMapLayout/StaticWeatherMapLayout';

const WeatherMapResizableLayout = ({
  mapContent,
  panelContent,
  isResizable = true,
  resizableOrientation = WEATHER_MAP_RESIZABLE_LAYOUT_DEFAULTS.resizableOrientation,
  nonResizableOrientation = WEATHER_MAP_RESIZABLE_LAYOUT_DEFAULTS.nonResizableOrientation,
  mapDefaultSize = WEATHER_MAP_RESIZABLE_LAYOUT_DEFAULTS.mapDefaultSize,
  panelDefaultSize = WEATHER_MAP_RESIZABLE_LAYOUT_DEFAULTS.panelDefaultSize,
  mapMinSize = WEATHER_MAP_RESIZABLE_LAYOUT_DEFAULTS.mapMinSize,
  panelMinSize = WEATHER_MAP_RESIZABLE_LAYOUT_DEFAULTS.panelMinSize,
  mapAriaLabel = 'Weather map',
  panelAriaLabel = 'Weather map information',
  resizeHandleAriaLabel = 'Resize weather map panels',
  containerClassName,
  mapClassName,
  panelClassName,
}) => {
  const requestedOrientation = isResizable ? resizableOrientation : nonResizableOrientation;
  const orientation = resolveWeatherMapLayoutOrientation(
    requestedOrientation,
    getDefaultWeatherMapLayoutOrientation(isResizable),
  );
  const sharedProps = {
    orientation,
    mapContent,
    panelContent,
    mapDefaultSize,
    panelDefaultSize,
    mapAriaLabel,
    panelAriaLabel,
    containerClassName,
    mapClassName,
    panelClassName,
  };

  if (!isResizable) {
    return <StaticWeatherMapLayout {...sharedProps} />;
  }

  return (
    <ResizableWeatherMapLayout
      {...sharedProps}
      mapMinSize={mapMinSize}
      panelMinSize={panelMinSize}
      resizeHandleAriaLabel={resizeHandleAriaLabel}
    />
  );
};

export default WeatherMapResizableLayout;
